import { Navigate } from 'react-router-dom';
import { routes } from '@platform/core/lib/routes';
import { RecordPage } from '@platform/engine/form/RecordPage';
import { RecordListPage } from '@platform/engine/list/RecordListPage';
import { useWorkspaceParams } from '@platform/hooks/useWorkspaceParams';

/**
 * Четвертий сегмент `/:group/:module/:entityOrPage/:idOrView` (ADR-028): під сутністю GUID (чи `new`) — запис, інакше — подання списку;
 * під сторінкою модуля зайвий сегмент веде на сторінку.
 */
export function RecordOrViewRoute() {
  const { module, rt, id, page } = useWorkspaceParams();
  if (!rt) return <Navigate to={page ? routes.modulePage(module, page) : routes.module(module)} replace />;
  return id ? <RecordPage /> : <RecordListPage />;
}
